"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretCircleDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CaretCircleDown = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "128", cy: "128", r: "96", fill: "none", stroke: "currentcolor", strokeMiterlimit: "10", strokeWidth: "16" }), (0, jsx_runtime_1.jsx)("polyline", { points: "164 116 128 156 92 116", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" })] })));
};
exports.CaretCircleDown = CaretCircleDown;
